var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * A request-only (managed) space is mutually exclusive with all other
 * spaces — an event holds either exactly one request-only space or any
 * number of scheduled ones. The incoming space wins: adding a request-only
 * space replaces the whole list, and adding a scheduled space drops any
 * request-only space already selected.
 *
 * Exception: organizer protection outranks request-only exclusivity (same
 * priority rule as normalizeSpaces). A managed space can never evict the
 * snapshot organizer, and the two can't coexist — the add folds back to a
 * no-op, returning `currentSpaces` BY REFERENCE so callers can detect the
 * fold-back and give the user feedback. Incoming-wins would otherwise
 * remove the organizer BEFORE the normalizer runs, blinding its collision
 * rule.
 *
 * Every path that appends a space to `form.spaces` must resolve through
 * this rule so no emitter (sider, search, cross-app patches) can mix them.
 */
export function resolveSpacesAfterAdd(currentSpaces, incomingSpace, 
/** `initialEvent.spaces` in EDIT; undefined in CREATE. */
initialSpaces) {
    var _a;
    if (incomingSpace.isManaged) {
        var organizerId_1 = (_a = initialSpaces === null || initialSpaces === void 0 ? void 0 : initialSpaces.find(function (space) { return space.isOrganizer; })) === null || _a === void 0 ? void 0 : _a.id;
        if (organizerId_1 !== undefined &&
            currentSpaces.some(function (space) { return space.id === organizerId_1; })) {
            return currentSpaces;
        }
        return [incomingSpace];
    }
    return __spreadArray(__spreadArray([], __read(currentSpaces.filter(function (space) { return !space.isManaged; })), false), [incomingSpace], false);
}
